import React from 'react';
import AccountsHierarchy from './AccountsHierarchy';

const OrganisationAccountsHierarchy = () => (
  <AccountsHierarchy
    header="ORGANISATION ACCOUNTS HIERARCHY"
    onlyFamilyAccounts={false}
  />
);

export default OrganisationAccountsHierarchy;
